import ApiService from "./ApiService";

const DashboardService = {
    getTotalByProvider() {
        return ApiService.get(`/dashboard/total-by-provider`);
    },

    getTotalPendingOrdersByProvider() {
        return ApiService.get(`/dashboard/pending-orders-by-provider`);
    },

    getTotalDeliveredOrdersByProvider() {
        return ApiService.get(`/dashboard/delivered-orders-by-provider`);
    }
};

export default DashboardService;
